<template>
  <Layout />
</template>

<script>
import Layout from './components/layout/Layout.vue';

export default {
  components: {
    Layout,
  },
};
</script>

<style lang="scss">
body {
  overflow-x: hidden;
}
</style>
